import type { WebsiteType } from "app/pages/sales-intelligence/domain/leads/types/enums";
import type { IWebsiteTypeFilterDto } from "app/pages/sales-intelligence/domain/leads/types/filter-values";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { IFilterPanelBaseFilterDeps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import type { FilterValueDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/misc";
import { calculateArrayDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/calculateValueDeltaUtils";
import type { WebsiteTypeDescription } from "app/pages/sales-intelligence/modules/leads-search-filters/types/description.dto";

import { mapArrayValues } from "../../utils/mapArrayValues";

import { FROM_API_EXCLUDE_VALUE, TO_API } from "./const";

export default class FindWebsiteTypeFilter extends FilterPanelBaseFilter<
    IWebsiteTypeFilterDto,
    readonly WebsiteTypeDescription[]
> {
    constructor(deps: IFilterPanelBaseFilterDeps<IWebsiteTypeFilterDto, readonly WebsiteTypeDescription[]>) {
        super(deps);
    }

    toApiValue(value: IWebsiteTypeFilterDto): IWebsiteTypeFilterDto {
        return {
            ...value,
            types: mapArrayValues(value?.types, TO_API, true),
        };
    }

    fromApiValue(apiValue: IWebsiteTypeFilterDto): IWebsiteTypeFilterDto {
        return {
            ...apiValue,
            types: apiValue?.types?.filter((type) => type !== FROM_API_EXCLUDE_VALUE),
        };
    }

    isValueEmpty(value: IWebsiteTypeFilterDto | undefined): boolean {
        return !value?.types?.length;
    }

    calculateValueDelta(
        previousValue?: IWebsiteTypeFilterDto,
        newValue?: IWebsiteTypeFilterDto,
    ): FilterValueDelta<WebsiteType> {
        return calculateArrayDelta(previousValue?.types, newValue?.types);
    }
}
